module.exports = __webpack_public_path__ + "static/assets/ebf8d8864f6254c96f4abd95db18e213.png";